import { Grid, Slider, Tooltip } from "@mui/material";
import { GridRenderCellParams } from "@mui/x-data-grid-pro";
import { T } from "components/alove/Translator";
import { ResponseType } from "models/batch/Question";
import { fileLink } from "utils/networkUtils";
import { MMNames } from "./MMnames";
import { formatDateOrTime, formatDateTime, tr } from "utils/globalsUtils";

const MDTypography = require("components/MDTypography").default;

export const ResponseCell = ({params,date}:{params: GridRenderCellParams, date?:Date}) => {
  const row = params.row;
  let value = row[params.field];
  if ([ResponseType.Scale, ResponseType.Range].includes(row.responseType) && value) {
    return (
      <Grid container flexDirection="row">
        <Grid alignSelf="center" size={2}>
          <Tooltip title={<T>{row.responseSettings?.txt_min || row.rangeMin || "0"}</T>}>
            <MDTypography style={{ fontSize: "12px" }} textAlign="center">
              {row.rangeMin || "0"}
            </MDTypography>
          </Tooltip>
        </Grid>
        <Grid size="grow">
          <Slider
            value={value.split(",").map(Number)}
            max={Number(row.rangeMax)}
            valueLabelDisplay="on"
            style={{ width: "100%", height: "100%" }}
          />
        </Grid>
        <Grid alignSelf="center" size={2}>
          <Tooltip title={<T>{row.responseSettings?.txt_max || row.rangeMax || "0"}</T>}>
            <MDTypography style={{ fontSize: "12px" }} textAlign="center">
              {row.rangeMax}
            </MDTypography>
          </Tooltip>
        </Grid>
      </Grid>
    );
  }
  if (row.responseType == ResponseType.Location && value) {
    const location = JSON.parse(value);
    return <div> {location?.city + ", " + location?.state}</div>;
  }
  if (row.responseType == ResponseType.List && value) {
    return <MMNames ids={value.split(",")} />;
  }
  if (row.responseType == ResponseType.FilePicker && value) {
    return (
      <a href={fileLink(value)} target="blank">
        {row.bioName}
      </a>
    );
  }

  const reported = date ? `</br><b>Reported:</b> ${formatDateTime(date)} ` : '';

  return (
    <Tooltip title={<p dangerouslySetInnerHTML={{ __html: value + reported}}></p>}>
      <p dangerouslySetInnerHTML={{ __html: tr(value) }}></p>
    </Tooltip>
  );
};
